<template>
<div class="DameraDetail">

    <Yinshiyun :data="yinshiyunData" />
    <div class="DameraDetail-address" v-show="itemData[0][0].value!=''">{{itemData[0][0].value}}</div>
    <div class="damera-detail-buttom">
          <circle-button @click="video_ptzcontrol_fn"></circle-button>
    </div>

    <div class="DameraDetail-bottom-btn">
        <div class="left btn" @click.stop="goVideoInfo">
            <div class="left-icon icon"></div>
            <div>基本信息</div>
        </div>
        <div class="fenge"></div>
        <div class="right btn" @click.stop="windows_fanzhuan">
            <div class="right-icon icon"></div>
            <div>画面翻转</div>
        </div>
    </div>

</div>
</template>

<script>
import {
    Component,
    Vue
} from "vue-property-decorator";
import {
    ajaxDeviceVideoInfo,
    ajax_yingshiyun_ptzcontrol_start,
    ajax_yingshiyun_ptzcontrol_stop,
    ajax_yingshiyun_ptzcontrol_mirror
} from "@/server";
import video_title from '../../../assets/image/video_title.png';
import Yinshiyun from '@/components/yinshiyun_video/Yinshiyun.vue';
import circleButton from '@/components/yinshiyun_video/circle_button.vue';

export default {
    name: 'dameraDetail',
    data() {
        return {
            type: 'loading',
            video_title: video_title,
            yinshiyunData: {
                type: '2',
                data: '',
                ip: '172.16.12.102',
                port: 80,
                username: 'admin',
                password: 'fubang123',
                ip_port: '',

                device_code: '180027271',
                rtmp_url: '',
                hls_url: '',
                yingshi_token: 'at.0p7nmpvraqt71oao3tkjk89z4sqgbmah-99qyusdgpi-1cz2cm0-svkcu3bta',

                company: '北京富邦智慧物联科技有限公司',
                address: '安装在研发部那个角落',
                click_status: false,
                ak: "0b8c404eb4214958b074287a1687be32" // 公有云平台注册即可获得accessKey

            },
            itemData: [
                [{
                    id: "desc",
                    name: "安装位置",
                    value: '',
                    jpath: 'info_device_video.desc'
                }]
            ]
        }
    },
    components: {
        Yinshiyun,
        circleButton
    },
    created() {
        document.title = "摄像头详情";
    },
    mounted() {
        this.getDeviceInfo();
    },
    methods: {
        // 方法*****************
        getDeviceInfo() {
            this.$indicator.open({
                text: '加载中...',
            });
            ajaxDeviceVideoInfo({
                uid: this.$store.state.user_info.info_user.user_id,
                device_id: this["$getObjectValue"](this["$route"], "query.device_id"),
            }).then(res => {
                let {
                    rtmp,
                    hls
                } = JSON.parse(res.data.info_device_video.trademark_url);
                this.yinshiyunData['rtmp_url'] = rtmp;
                this.yinshiyunData['hls_url'] = hls;

                this.yinshiyunData['device_code'] = this.$getObjectValue(res.data, 'info_device_video.device_code');
                this.yinshiyunData['yingshi_token'] = this.$getObjectValue(res.data, 'token.accessToken');


                // console.log(this.yinshiyunData['yingshi_token'])

                this.$getDataInit(this.itemData, res.data);
            }).catch(error => {
                console.log(error);
            }).finally(res => {
                this['$indicator'].close();
            });
        },
        // 详情列表进入
        goVideoInfo() {
            this.$router.push({
                path: '/weixin/communityfire/dameradetailInfo',
                query: this.$route['query']
            })
        },
        video_ptzcontrol(type, vue) {

            this.start = null;
            this.stop = null;


            // console.log(vue.yinshiyunData['yingshi_token']);

            //云台方向
            var ptzDirection = {
                up: 0,
                down: 1,
                left: 2,
                right: 3,
                leftUp: 4,
                leftDown: 5,
                rightUp: 6,
                rightDown: 7
            };
            //云台镜头控制
            var ptzCamera = {
                doubleAdd: 8,
                doubleSub: 9,
                focalAdd: 10,
                focalSub: 11,
                diaphragmAdd: 0,
                diaphragmSub: 0
            };
            var _t = 1;
            var _a = 1;
            var _type = '';
            switch (type) {
                case 'up_left':
                    _type = 'direction';
                    _t = ptzDirection.leftUp;
                    break;
                case 'up':
                    _type = 'direction';
                    _t = ptzDirection.up;
                    break;
                case 'up_right':
                    _type = 'direction';
                    _t = ptzDirection.rightUp;
                    break;
                case 'left':
                    _type = 'direction';
                    _t = ptzDirection.left;
                    break;
                case 'right':
                    _type = 'direction';
                    _t = ptzDirection.right;
                    break;
                case 'down_left':
                    _type = 'direction';
                    _t = ptzDirection.leftDown;
                    break;
                case 'down':
                    _type = 'direction';
                    _t = ptzDirection.down;
                    break;
                case 'down_right':
                    _type = 'direction';
                    _t = ptzDirection.rightDown;
                    break;
                case 'scale_big':
                    _type = 'direction';
                    _a = ptzCamera.doubleAdd;
                    break;
                case 'scale_small':
                    _type = 'direction';
                    _a = ptzCamera.doubleSub;
                    break;
                case 'focus_big':
                    _type = 'direction';
                    _a = ptzCamera.focalAdd;
                    break;
                case 'focus_small':
                    _type = 'direction';
                    _a = ptzCamera.focalSub;
                    break;
                case 'aperture_big':
                    _type = 'camera';
                    _a = ptzCamera.diaphragmAdd;
                    break;
                case 'aperture_small':
                    _type = 'camera';
                    _a = ptzCamera.diaphragmSub;
                    break;
            }

            if (_type == 'direction') {
                var get_data = {
                    deviceSerial: vue.yinshiyunData['device_code'],
                    channelNo: 1,
                    accessToken: vue.yinshiyunData['yingshi_token'],
                    direction: _t,
                    speed: 0
                }

                var fromData=new FormData();
                             

                for(let index in get_data){
                    fromData.append(index,get_data[index])
                }

                function start() {
                    ajax_yingshiyun_ptzcontrol_start(fromData).then(res => {
                        console.log('云台控制成功');
                    }).catch(error => {
                        console.log('云台控制失败')
                    })
                }

                function stop() {
                    ajax_yingshiyun_ptzcontrol_stop(fromData).then(res => {
                        console.log('云台控制成功');
                    }).catch(error => {
                        console.log('云台控制失败')
                    })
                }

                this.start = start;
                this.stop = stop;

            } else if (_type == 'camera') {
                console.log('云台不支持此功能')
            }

        },

        video_morror(){
            var get_data = {
                deviceSerial: this.yinshiyunData['device_code'],
                channelNo: 1,
                accessToken: this.yinshiyunData['yingshi_token'],
                command:2
            }

            var fromData=new FormData();
                            
            for(let index in get_data){
                fromData.append(index,get_data[index])
            }

            ajax_yingshiyun_ptzcontrol_mirror(fromData).then(res=>{
                this.$message({
                    value:'镜头翻转成功'
                })
            }).catch(error=>{
                  this.$message({
                    value:error.msg||'镜头翻转失败'
                })
            })
        },

        /** 画面翻转 */
        windows_fanzhuan(){
            this.video_morror();
        },

        video_ptzcontrol_fn(data) {
            let ptzcontrol = new this.video_ptzcontrol(data.index, this);
            if (data.type === 'start') {
                ptzcontrol.start();
            } else {
                ptzcontrol.stop();
            }
        }
    },
};
</script>

<style lang="less" scoped>
@import url("../../../assets/less-css/flexible.less");

.DameraDetail {
    height: 100%;
    // background: #f2f2f2;
    background: #fff;
    position: relative;

    .video-box {
        background: #fff;
    }

    .video-top-box {
        .lh(72);
        .h(72);
        .fs(22);
        display: flex;
        align-items: center;
        .px2rem(padding-left, 20);
        position: relative;

        button {
            display: flex;
            align-items: center;
            position: absolute;
            .r(20);
            background: #fff;
            border: 1px solid #cccccc;
            color: #333;
            .br(30);
            .p(5);
            .px2rem(padding-left, 20);
            .px2rem(padding-right, 20);
        }

        img {
            .w(30);
            .h(30);
            .px2rem(margin-right, 12);
        }
    }

    .DameraDetail-address{
        width: 100%;
        .h(88);
        .fs(34);
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-bottom: solid 1px #e7e7e7;

    }
    .DameraDetail-bottom-btn{
        width: 100%;
        height: 40px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        .fs(30);
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: solid 1px #e7e7e7;
        .fenge{
            width: 1px;
            height: 52%;
            background-color: #dddddd;
        }
   
        .btn{
            width: 50%;
            height: 100%;
            text-align: center;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #666666;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        
        .icon{
            // .w(26);
            // .h(26);
            width: 14px;
            height: 14px;
            margin-right: 10px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
        }

        .left-icon{
            background-image: url('../../../assets/image/video-dateal-info.png');
        }
        .right-icon{
            background-image: url('../../../assets/image/video-fanzhuan.png');
        }

    }
}
.damera-detail-buttom{
  width: 100%;
  height: auto;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.DetailsShow{
  margin-bottom: 0px;
}
</style>
